import { PageFrame } from "../../components/page_frame";
import { InventoryHealthForHubsContainer } from "./container";

export default function InventoryHealthForHubsPage() {
  return (
    <PageFrame>
      <InventoryHealthForHubsContainer />
    </PageFrame>
  );
}
